export const BREEDS = [
  'Mixed / Crossbreed', 'Labrador Retriever', 'Golden Retriever', 'German Shepherd', 'French Bulldog',
  'Bulldog', 'Poodle', 'Beagle', 'Rottweiler', 'Dachshund', 'Yorkshire Terrier', 'Boxer',
  'Cavalier King Charles Spaniel', 'Cocker Spaniel', 'Shih Tzu', 'Miniature Schnauzer',
  'Border Collie', 'Staffordshire Bull Terrier', 'Jack Russell Terrier', 'Chihuahua',
  'Husky', 'Dalmatian', 'Whippet', 'Cockapoo', 'Labradoodle', 'Springer Spaniel',
  'West Highland Terrier', 'Pug', 'Lhasa Apso', 'Bichon Frise', 'Other',
];

export const AGE_OPTIONS = [
  { value: 'puppy-8-weeks', label: '8–12 weeks' },
  { value: 'puppy-3-months', label: '3–6 months' },
  { value: 'puppy-6-months', label: '6–12 months' },
  { value: '1-year', label: '1–2 years' },
  { value: '3-years', label: '3–5 years' },
  { value: '6-years', label: '6–7 years' },
  { value: '8-years', label: '8–10 years' },
  { value: '11-years', label: '11+ years' },
];
